import { getDataWithoutOrganisationId } from './dataOrganisationUtils';

export const getDataArrayWithOrganisationIds = (
dataArray,
getOrganisationId) =>
dataArray.map((item) => ({ ...item, organisationId: getOrganisationId(item) }));

export const getDataArrayWithoutOrganisationIds = (dataArray) =>
dataArray.map(getDataWithoutOrganisationId);